import { Box } from '@fairfashion/design-system'

import * as Styles from './chart-image.styles'
import { ChartImageProps } from './chart-image.types'

export const ChartImage = ({ size, color }: ChartImageProps) => {
  return (
    <Box
      width={`${size}px`}
      height={`${(64 * size) / 128}px`}
      position="relative"
      overflow="hidden"
    >
      <Styles.ChartImage>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 128 64"
          fill="none"
        >
          <path
            opacity="0.2"
            d="M128 64V0L123.848 5.76904C119.697 11.5375 111.396 23.0721 103.095 29.8008C94.7938 36.53 86.4922 38.4526 78.1906 32.6848C75.0281 30.4875 71.8656 27.1742 68.7031 23.8608C63.564 18.4766 58.425 13.0923 53.2859 12.4971C46.0913 11.6639 38.8967 20.2174 31.7021 28.7709C30.5951 30.0869 29.4882 31.403 28.3812 32.6848C20.0797 42.298 11.7781 49.9885 3.47656 51.9111C2.31771 52.1795 1.15885 52.3355 0 52.3791V64H128Z"
            fill={color}
          />
        </svg>
      </Styles.ChartImage>
      <Styles.ChartImage>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 128 52"
          fill="none"
        >
          <path
            opacity="0.2"
            d="M128 21.7649V52H0V30.5232C3.44922 33.32 6.89258 35.9598 10.3359 37.971C21.3544 44.4068 32.3729 44.4068 43.3914 36.6838C48.9006 32.8223 54.4583 27.0302 60.0158 21.238C65.5734 15.4458 71.131 9.65371 76.6402 5.79219C87.6587 -1.93073 98.6772 -1.93073 109.696 5.79219C113.34 8.34663 116.985 11.7459 120.636 15.1518C123.087 17.4377 125.541 19.7266 128 21.7649Z"
            fill={color}
          />
        </svg>
      </Styles.ChartImage>
    </Box>
  )
}
